import { Pipe, PipeTransform } from '@angular/core';
import { DepartmentEstimate } from '@interfaces/DepartmentEstimate';

@Pipe({
  name: 'expenseCost'
})
export class ExpenseCostPipe implements PipeTransform {
  public transform(departmentEstimate: DepartmentEstimate): number {
    let cost = 0;

    for (const estimateLine of departmentEstimate.estimateLines) {
      if (estimateLine.expenseLine) {
        cost = estimateLine.expenseLine.amountCost || 0;
      }
    }
    return cost;
  }
}
